import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/auth/exit.svg'
import _imports_1 from '@/assets/logo-tracker.svg'


const _hoisted_1 = {
  key: 0,
  class: "page-layout__spinner"
}
const _hoisted_2 = { class: "page-layout" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "layout-navigation-placeholder" }, null, -1)
const _hoisted_4 = { class: "layout-navigation" }
const _hoisted_5 = {
  key: 0,
  class: "navigation-logo"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "navigation-logo"
}
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "navigation-profile-avatar" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "navigation-profile-avatar-edit" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1.6463,14.353A.4962.4962,0,0,0,2,14.5a.5939.5939,0,0,0,.138-.018l4.199-1.2.0078-.0026a.121.121,0,0,0,.0232-.0094l.04-.017a.4819.4819,0,0,0,.146-.099l7.179-7.179a2.622,2.622,0,0,0-3.708-3.708L2.8463,9.446a.4949.4949,0,0,0-.1.147l-.009.02.001-.001a.4291.4291,0,0,0-.019.05l-1.2,4.2A.5.5,0,0,0,1.6463,14.353Zm3.6-1.8-2.518.719.72-2.517Zm.954-.46,5.572-5.572L9.4793,4.228,3.9073,9.8Zm6.826-6.826-.547.547-2.293-2.293.547-.547a1.6236,1.6236,0,0,1,2.293,0A1.6236,1.6236,0,0,1,13.0263,5.267Z",
      "fill-rule": "evenodd"
    })
  ])
], -1)
const _hoisted_13 = { class: "navigation-profile-name" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "navigation-profile-arrow" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "10",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "5.95 10 0.646 4.697 1.354 3.99 5.95 8.586 10.546 3.99 11.253 4.697 5.95 10",
      fill: "#8b8b8b"
    })
  ])
], -1)
const _hoisted_15 = { class: "navigation-menu" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M26.9219,6.4282l-6.25-2.5a2.0621,2.0621,0,0,0-1.5313,0L12.4878,6.59a1.0606,1.0606,0,0,1-.3922.0761l-.0018,0-.0016,0A1.0579,1.0579,0,0,1,11.7,6.59L5.5386,4.1255A1.282,1.282,0,0,0,3.7812,5.3193V20.291a2.0534,2.0534,0,0,0,1.2969,1.9151l6.2505,2.5009a2.0538,2.0538,0,0,0,1.5308-.0009l3.001-1.2012a.5.5,0,1,0-.3721-.9278l-2.8945,1.1581V7.5967a2.061,2.061,0,0,0,.2656-.0781l6.5468-2.62v7.1951a.5.5,0,1,0,1,0V4.8991l6.1446,2.4578a1.0565,1.0565,0,0,1,.668.9869V12.875a.5.5,0,0,0,1,0V8.3438A2.0526,2.0526,0,0,0,26.9219,6.4282ZM5.45,21.2783a1.06,1.06,0,0,1-.6685-.9873V5.3169A.2882.2882,0,0,1,4.8018,5.21a.2824.2824,0,0,1,.3657-.1558l6.1606,2.4644a2.0619,2.0619,0,0,0,.2657.078v16.14Zm17.7786-.4441a.4974.4974,0,0,1-.1971.0408.8915.8915,0,0,1-.8906-.8906l0-.0005,0,0a.879.879,0,0,1,.6956-.8512.5025.5025,0,0,1,.39,0,.8677.8677,0,0,1,.6561.6562.5011.5011,0,0,1,0,.39A.8677.8677,0,0,1,23.2283,20.8342Zm-.2,7.3846a1.2693,1.2693,0,0,1-.7871-.2725,1.2863,1.2863,0,0,1-.2187-.2188c-1.5606-1.9941-4.1787-5.6523-4.1787-7.7441a5.1875,5.1875,0,1,1,10.375,0c0,2.0889-2.6182,5.748-4.1788,7.7432a1.2714,1.2714,0,0,1-.8545.4834A1.4266,1.4266,0,0,1,23.0283,28.2188Zm.0029-12.4229a4.1927,4.1927,0,0,0-4.1874,4.1875c0,1.29,1.4824,3.9541,3.9658,7.127a.32.32,0,0,0,.2558.1064.2821.2821,0,0,0,.1875-.1055c2.4834-3.1758,3.9659-5.84,3.9659-7.1279A4.1928,4.1928,0,0,0,23.0312,15.7959Z" })
], -1)
const _hoisted_17 = { class: "navigation-logout" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: 'logout'
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "navigation-locale" }
const _hoisted_21 = {
  href: "https://www.tracker.com/",
  class: "navigation-powered",
  target: "_blank"
}
const _hoisted_22 = ["alt"]
const _hoisted_23 = { class: "navigation-old-frontend" }
const _hoisted_24 = {
  href: "https://admin.tracker.com/",
  class: "redirect-button",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vLottiePlayer = _resolveComponent("vLottiePlayer")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_user_settings_modal = _resolveComponent("user-settings-modal")!
  const _component_terms_and_conditions_modal = _resolveComponent("terms-and-conditions-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isPending)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_vLottiePlayer, {
            name: "workoutMonkeyAnim",
            loop: "",
            animationData: require('@/assets/lottie/loader.json')
          }, null, 8, ["animationData"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (!!_ctx.companyUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("a", {
                href: _ctx.companyUrl,
                rel: "external",
                class: "redirect-button",
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: _ctx.companyPicture,
                  alt: _ctx.$t('pages.layout.logo_alt')
                }, null, 8, _hoisted_7)
              ], 8, _hoisted_6)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("img", {
                src: _ctx.companyPicture,
                alt: _ctx.$t('pages.layout.logo_alt')
              }, null, 8, _hoisted_9)
            ])),
        _createElementVNode("div", {
          class: _normalizeClass({ 'navigation-content': true, 'navigation-content--open': _ctx.mobileNavOpen })
        }, [
          _createElementVNode("button", {
            class: "navigation-profile",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openUserModalSettings && _ctx.openUserModalSettings(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                class: "navigation-profile-avatar-image",
                src: _ctx.userPicture,
                alt: _ctx.userName
              }, null, 8, _hoisted_11),
              _hoisted_12
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.userName), 1),
            _hoisted_14
          ]),
          _createElementVNode("nav", _hoisted_15, [
            _createVNode(_component_router_link, {
              to: { name: 'maps' },
              "exact-active-class": "active"
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('pages.layout.navigation.maps')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "navigation-logout-btn",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logoutEvent && _ctx.logoutEvent(...args)), ["prevent"]))
            }, _hoisted_19)
          ]),
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.serverLocale.toUpperCase()), 1),
          _createElementVNode("a", _hoisted_21, [
            _createTextVNode(_toDisplayString(_ctx.$t('pages.auth.login.powered_by')) + " ", 1),
            _createElementVNode("img", {
              src: _imports_1,
              alt: _ctx.$t('pages.auth.login.powered_by_alt')
            }, null, 8, _hoisted_22)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("a", _hoisted_24, _toDisplayString(_ctx.$t('pages.auth.login.old_frontend')), 1)
          ])
        ], 2)
      ]),
      _createVNode(_component_router_view),
      _createVNode(_Transition, {
        name: "modal",
        duration: 1000
      }, {
        default: _withCtx(() => [
          (!_ctx.isTermsAndConditionsModalOpen && _ctx.modalLogoutOpen)
            ? (_openBlock(), _createBlock(_component_user_settings_modal, {
                key: 0,
                "is-mobile": false,
                username: _ctx.userName,
                email: _ctx.userEmail,
                "default-settings": _ctx.defaultSettings,
                text: _ctx.$t('pages.auth.logout.text'),
                "button-text": _ctx.$t('pages.auth.logout.button'),
                "user-picture-url": _ctx.userPicture,
                settings: _ctx.userSettings,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalLogoutOpen = false))
              }, null, 8, ["username", "email", "default-settings", "text", "button-text", "user-picture-url", "settings"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.isTermsAndConditionsModalOpen && _ctx.isUserModalVisible)
        ? (_openBlock(), _createBlock(_component_user_settings_modal, {
            key: 0,
            "is-mobile": true,
            username: _ctx.userName,
            email: _ctx.userEmail,
            "default-settings": _ctx.defaultSettings,
            text: _ctx.$t('pages.auth.logout.text'),
            "button-text": _ctx.$t('pages.auth.logout.button'),
            "user-picture-url": _ctx.userPicture,
            settings: _ctx.userSettings,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeUserModalVisibility()))
          }, null, 8, ["username", "email", "default-settings", "text", "button-text", "user-picture-url", "settings"]))
        : _createCommentVNode("", true),
      (_ctx.width > 767)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 1,
            name: "modal",
            duration: 1000
          }, {
            default: _withCtx(() => [
              (_ctx.isTermsAndConditionsModalOpen || !_ctx.gtcAccepted)
                ? (_openBlock(), _createBlock(_component_terms_and_conditions_modal, {
                    key: 0,
                    "is-mobile": false,
                    "is-accepted": _ctx.gtcAccepted,
                    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeTermsAndConditionsModal()))
                  }, null, 8, ["is-accepted"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ((_ctx.isTermsAndConditionsModalOpen || !_ctx.gtcAccepted) && _ctx.width <= 767)
        ? (_openBlock(), _createBlock(_component_terms_and_conditions_modal, {
            key: 2,
            "is-mobile": true,
            "is-accepted": _ctx.gtcAccepted,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeTermsAndConditionsModal()))
          }, null, 8, ["is-accepted"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}